var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9562 14.8359C24.7388 14.8359 26.5218 15.5128 27.8774 16.8685C30.3937 19.3848 30.5737 23.3724 28.4194 26.1003L32.0844 29.7653C32.1604 29.8411 32.2207 29.9312 32.2619 30.0303C32.303 30.1295 32.3242 30.2358 32.3242 30.3432C32.3242 30.4505 32.303 30.5568 32.2619 30.656C32.2207 30.7552 32.1604 30.8452 32.0844 30.921C32.0086 30.9973 31.9184 31.0578 31.8191 31.0991C31.7198 31.1404 31.6133 31.1616 31.5057 31.1616C31.3982 31.1616 31.2917 31.1404 31.1924 31.0991C31.0931 31.0578 31.0029 30.9973 30.9271 30.921L27.2621 27.2561C24.5338 29.4071 20.5467 29.2305 18.0319 26.7156C15.3206 24.0044 15.3238 19.5798 18.0351 16.8685C19.3908 15.5128 21.1736 14.8359 22.9562 14.8359ZM22.9546 16.4556C21.5923 16.4545 20.2297 16.9758 19.186 18.0195C17.0985 20.1069 17.0985 23.4724 19.186 25.5599C21.2735 27.6473 24.6357 27.6442 26.7232 25.5568C28.8107 23.4693 28.8107 20.1118 26.7232 18.0244C25.6795 16.9806 24.3169 16.4567 22.9546 16.4556Z",
    fill: "#939AA8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.33594,
    width: 47.3242,
    height: 43.3257,
    rx: 5.5,
    stroke: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.9731b7b641cc6ac38b5dd38042ddad3d.svg";
export { ForwardRef as ReactComponent };